import { UseMutateFunction } from '@tanstack/react-query';

import { AllocationCreateRequest } from '@ndvr/portfolio-api';

import { FormValues } from 'views/portfolio-engine/allocation-builder/allocations/edit-dialog/EditAllocationDialog';

interface UseAllocationDialogSaveProps {
    createAllocation: UseMutateFunction<string | undefined, Error, AllocationCreateRequest, unknown>;
    onSuccess: (allocationGUID: string) => void;
    onDialogClose: () => void;
}

export const useAllocationDialogSave = ({
    createAllocation,
    onSuccess,
    onDialogClose,
}: UseAllocationDialogSaveProps) => {
    return (data: FormValues) => {
        createAllocation(
            {
                allocationName: data.allocationName,
                allocationGroupName: data.allocationName,
                allocationType: data.allocationType,
                strategyAllocations: data.strategyAllocations,
            },
            {
                onSuccess: (newAllocationGUID) => {
                    const allocationGUID = typeof newAllocationGUID === 'string' ? newAllocationGUID : undefined;
                    if (allocationGUID) {
                        onSuccess(allocationGUID);
                    }
                    onDialogClose();
                },
            },
        );
    };
};
